export default __webpack_public_path__ + "static/media/Reader's Cowl of the Crescent.03de1bd9.jpg";